export const actions = {
  SET_BREADCRUMBS: 'SERVICE_SELECTOR::SET_BREADCRUMBS',
  SET_ACTIVE_TAXONOMY_NODE: 'SERVICE_SELECTOR::SET_ACTIVE_TAXONOMY_NODE',
};

export function setActiveTaxonomyNode(activeTaxonomyNode = null) {
  return {
    type: actions.SET_ACTIVE_TAXONOMY_NODE,
    payload: {activeTaxonomyNode},
  };
}

export function setBreadcrumbs(breadcrumbs = []) {
  return {
    type: actions.SET_BREADCRUMBS,
    payload: {breadcrumbs},
  };
}
